export enum Ethnicity {
    'Hispanic/Latino',
    'Not Hispanic/Latino',
}
